import { inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export class ModalWindowClass<T> {
  private readonly dialogRef = inject(MatDialogRef<T>);
  
  public onDialogAction(): void {
    this.dialogRef.close(true);
  }
}
